"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sinceUpdated = exports.updatedAt = exports.zone = exports.sinceCreated = exports.createdAt = undefined;

var _reselect = require("reselect");

var _now = require("../../now");

var Now = _interopRequireWildcard(_now);

var _raw = require("./raw");

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//import _ from "lodash"
var createdAt = exports.createdAt = (0, _reselect.createSelector)(Raw.getInitEvent, function (s) {
  return s.createdAt;
});
var sinceCreated = exports.sinceCreated = Now.since(createdAt);
var zone = exports.zone = (0, _reselect.createSelector)(Raw.getInitEvent, function (s) {
  return s.zone;
});
var updatedAt = exports.updatedAt = (0, _reselect.createSelector)(Raw.getEvent, function (s) {
  return s.createdAt;
});
var sinceUpdated = exports.sinceUpdated = Now.since(updatedAt);
//export const isDone = () => false // TODO
//export const isRunning = _.negate(isDone)
//export const doneAt = () => 0 // TODO
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvY29tYmF0L2NvbWJhdC5qcyJdLCJuYW1lcyI6WyJOb3ciLCJSYXciLCJjcmVhdGVkQXQiLCJnZXRJbml0RXZlbnQiLCJzIiwic2luY2VDcmVhdGVkIiwic2luY2UiLCJ6b25lIiwidXBkYXRlZEF0IiwiZ2V0RXZlbnQiLCJzaW5jZVVwZGF0ZWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFDQTs7QUFFQTs7SUFBWUEsRzs7QUFDWjs7SUFBWUMsRzs7OztBQUZaO0FBSU8sSUFBTUMsZ0NBQVksOEJBQWVELElBQUlFLFlBQW5CLEVBQWlDO0FBQUEsU0FBS0MsRUFBRUYsU0FBUDtBQUFBLENBQWpDLENBQWxCO0FBQ0EsSUFBTUcsc0NBQWVMLElBQUlNLEtBQUosQ0FBVUosU0FBVixDQUFyQjtBQUNBLElBQU1LLHNCQUFPLDhCQUFlTixJQUFJRSxZQUFuQixFQUFpQztBQUFBLFNBQUtDLEVBQUVHLElBQVA7QUFBQSxDQUFqQyxDQUFiO0FBQ0EsSUFBTUMsZ0NBQVksOEJBQWVQLElBQUlRLFFBQW5CLEVBQTZCO0FBQUEsU0FBS0wsRUFBRUYsU0FBUDtBQUFBLENBQTdCLENBQWxCO0FBQ0EsSUFBTVEsc0NBQWVWLElBQUlNLEtBQUosQ0FBVUUsU0FBVixDQUFyQjtBQUNQO0FBQ0E7QUFDQSIsImZpbGUiOiJjb21iYXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IHtjcmVhdGVTZWxlY3Rvcn0gZnJvbSBcInJlc2VsZWN0XCJcbi8vaW1wb3J0IF8gZnJvbSBcImxvZGFzaFwiXG5pbXBvcnQgKiBhcyBOb3cgZnJvbSBcIi4uLy4uL25vd1wiXG5pbXBvcnQgKiBhcyBSYXcgZnJvbSBcIi4vcmF3XCJcblxuZXhwb3J0IGNvbnN0IGNyZWF0ZWRBdCA9IGNyZWF0ZVNlbGVjdG9yKFJhdy5nZXRJbml0RXZlbnQsIHMgPT4gcy5jcmVhdGVkQXQpXG5leHBvcnQgY29uc3Qgc2luY2VDcmVhdGVkID0gTm93LnNpbmNlKGNyZWF0ZWRBdClcbmV4cG9ydCBjb25zdCB6b25lID0gY3JlYXRlU2VsZWN0b3IoUmF3LmdldEluaXRFdmVudCwgcyA9PiBzLnpvbmUpXG5leHBvcnQgY29uc3QgdXBkYXRlZEF0ID0gY3JlYXRlU2VsZWN0b3IoUmF3LmdldEV2ZW50LCBzID0+IHMuY3JlYXRlZEF0KVxuZXhwb3J0IGNvbnN0IHNpbmNlVXBkYXRlZCA9IE5vdy5zaW5jZSh1cGRhdGVkQXQpXG4vL2V4cG9ydCBjb25zdCBpc0RvbmUgPSAoKSA9PiBmYWxzZSAvLyBUT0RPXG4vL2V4cG9ydCBjb25zdCBpc1J1bm5pbmcgPSBfLm5lZ2F0ZShpc0RvbmUpXG4vL2V4cG9ydCBjb25zdCBkb25lQXQgPSAoKSA9PiAwIC8vIFRPRE9cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/combat/combat.js
// module id = 92
// module chunks = 0